import React from "react";
import { Trash2, Eye, EyeOff, ScanSearch } from "lucide-react";
import OrderedIconActionContextRow from "../../ui/OrderedIconActionContextRow";
import { ReparentMenuIcon } from "./icons";
import SceneGraphReparentBodyList from "./SceneGraphReparentBodyList";

export default function SceneGraphInertialContextMenu({
  contextMenuInertialKeys,
  contextMenuInertialSourceBodyUuids,
  reparentSubmenuOpen,
  setReparentOnlySubmenuKey,
  closeContextSubmenus,
  setContextMenuOpen,
  isPhysicsRunning,
  worldRootTargetBodyUuid,
  groupedInertialParentOptions,
  bodies,
  viewerActions,
  inertialVisibility,
  inspectContextMenuTarget,
  handleDeleteInertials,
  handleMoveInertialsToBody,
}) {
  return (
    <>
      <div className="px-2 py-1.5 text-[11px] font-semibold text-gray-400 uppercase tracking-wide">
        {contextMenuInertialKeys.length}{" "}
        {contextMenuInertialKeys.length === 1 ? "inertial" : "inertials"} selected
      </div>
      <div className="px-2 pb-1.5">
        <OrderedIconActionContextRow
          activeSubmenuKey={reparentSubmenuOpen ? "reparent" : null}
          setActiveSubmenuKey={setReparentOnlySubmenuKey}
          submenuClassName="mt-1 min-w-[180px] rounded-md border border-gray-600 p-0.5 shadow-xl"
          submenuStyle={{ backgroundColor: "rgba(40, 40, 40, 0.95)" }}
          actions={[
            {
              key: "inspect",
              label: "Inspect",
              icon: <ScanSearch className="w-4 h-4" aria-hidden="true" />,
              onDefaultClick: inspectContextMenuTarget,
            },
            (() => {
              const allInertialVisible = contextMenuInertialKeys.every(
                (key) => inertialVisibility[key] !== false
              );
              return {
                key: "visibility",
                label: allInertialVisible ? "Hide" : "Show",
                icon: allInertialVisible ? (
                  <EyeOff className="w-4 h-4" aria-hidden="true" />
                ) : (
                  <Eye className="w-4 h-4" aria-hidden="true" />
                ),
                disabled: isPhysicsRunning,
                disabledByPhysics: isPhysicsRunning,
                onDefaultClick: () => {
                  if (isPhysicsRunning) return;
                  contextMenuInertialKeys.forEach((key) =>
                    viewerActions.setInertialVisibility(key, !allInertialVisible)
                  );
                  setContextMenuOpen(false);
                },
              };
            })(),
            {
              key: "delete",
              label: "Delete",
              icon: <Trash2 className="w-4 h-4" aria-hidden="true" />,
              disabled: isPhysicsRunning,
              disabledByPhysics: isPhysicsRunning,
              onHover: closeContextSubmenus,
              onClick: () => handleDeleteInertials(contextMenuInertialKeys),
            },
            {
              key: "reparent",
              label: "Reparent",
              icon: <ReparentMenuIcon />,
              disabled:
                isPhysicsRunning ||
                contextMenuInertialKeys.length !== 1 ||
                contextMenuInertialSourceBodyUuids.size !== 1,
              disabledByPhysics: isPhysicsRunning,
              onDefaultClick: () => {
                if (
                  isPhysicsRunning ||
                  contextMenuInertialKeys.length !== 1 ||
                  contextMenuInertialSourceBodyUuids.size !== 1 ||
                  !worldRootTargetBodyUuid
                ) {
                  return;
                }
                handleMoveInertialsToBody(worldRootTargetBodyUuid);
              },
              submenu:
                contextMenuInertialKeys.length === 1 &&
                contextMenuInertialSourceBodyUuids.size === 1 ? (
                  <SceneGraphReparentBodyList
                    groupedParentOptions={groupedInertialParentOptions}
                    bodies={bodies}
                    onSelectBody={handleMoveInertialsToBody}
                    filterBody={(body) =>
                      body?.uuid &&
                      (!body.inertia || contextMenuInertialSourceBodyUuids.has(body.uuid))
                    }
                  />
                ) : null,
            },
          ]}
        />
      </div>
    </>
  );
}
